export enum ScrollerOption {
	AUTOMATIC = 'auto',
	SCROLLING = 'scrolling',
	ALWAYS = 'always',
}
